export default __webpack_public_path__ + "static/media/fifth.66988ee7.mp4";